import PhoneNumberFormPanel from './PhoneNumberFormPanel';

export default PhoneNumberFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/PhoneNumberFormPanel/index.js